import { Add } from "@mui/icons-material";
import { Box, Container, Grid, Typography } from "@mui/material";
import  { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsers, getUser } from "../../redux/actions/user.actions";
import CreateModal from "./CreateModal";
import UserCard from "./UserCard";
import { useLocation } from "react-router-dom";
import { FaUsers } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa"; // or any icon
import StatsCard from "../../components/Comman/cards";
import CardWithButton from "../../components/Comman/button-new";
import CommonModal from "../../components/Comman/modal-view";

const Users = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { users } = useSelector((state) => state.userReducer);
  const loginUser = useSelector((state) => state?.authReducer?.user);
  const [openModal, setOpenModal] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [viewData,setViewData] = useState({})

  const handleModal = (value) => {
    setOpenModal(value);
    setisEdit(false);
  };

  const updateUser = (id) => {
    dispatch(getUser(id)).then((res) => {
      setOpenModal(true);
      setisEdit(true);
    });
  };


  const [token, setToken] = useState("")
  useEffect(() => {
    if (token) dispatch(getAllUsers());
    setToken(localStorage.getItem("token"));
  }, [token, dispatch]);


  const handleViewFunc=(info)=>{
      setViewData(info)
      setOpen(true)
  }


  return (
    <Container className="user-management " >
      <Grid
        container
        direction="column"
        spacing={5}
        marginBottom={16}
        style={{
          border: "1px solid rgba(0, 0, 0, 0.1)", 
          padding: "20px",
        }}
        className="shadow-md bg-white rounded"
      >
        <Grid
          container
          item
          spacing={6}
          direction="row"
          justifyContent="space-around"
          className="p-0"
        >
          <StatsCard heading="ADMINS" icon={<FaUserTie />} content={users.adminCount} />
          <StatsCard heading="USERS" icon={<FaUsers />} content={users.userCount} />
        </Grid>
        {(loginUser?.role === "Admin" && loginUser !== null) ? (
          <CardWithButton
            title="Add New User"
            className=""
            buttonLabel="Add User"
            buttonIcon={<Add />}
            buttonClick={() => handleModal(true)}
          />
        ) : (
          ""
        )}

        <Grid item>
          <Box sx={{ flexGrow: 1 }}>
            <div className="container">
              <div className="row gy-2">
                {Array.isArray(users?.users)
                  ? users?.users.map((user) => {
                    return (
                      <UserCard
                        key={user.id}
                        handleUpdate={(id) => updateUser(id)}
                        user={user}
                        loginUser={loginUser}
                        handleView={()=>handleViewFunc(user)}
                      />
                    );
                  })
                  : ""}
              </div>
            </div>
          </Box>
        </Grid>
      </Grid>
      {openModal && (
        <CreateModal
          handleModal={handleModal}
          openModal={openModal}
          isEdit={isEdit}
          location={location}
        />
      )}
       <CommonModal
                open={open}
                onClose={() => setOpen(false)}
                title="User Details"
                showActions={false}
            >
                <Typography className="text-primary"><strong >ID:</strong> {viewData.id}</Typography>
                <Typography className="text-success"><strong>Name:</strong> {viewData.name}</Typography>
                <Typography><strong>Email:</strong> {viewData.email}</Typography>
                <Typography><strong>Mobile:</strong> {viewData.mobile}</Typography>
                <Typography><strong>Role:</strong> {viewData.role}</Typography>
            </CommonModal>
    </Container>
  );
};

export default Users;
